// Menu "Marketing" (decisão Ivan 25/08/2026): hub único de aquisição.
// Reúne o que vivia espalhado — Estúdio Social (menu próprio), Meta Ads /
// Automação de comentários / Prospecção / Links & QR (dentro de CRM →
// Captação) e Campanhas (menu próprio). As ROTAS não mudam: só a organização.
// Gates continuam vindo do meta das rotas (provider.js) — mover item de menu
// não altera permissão nem feature flag.
// `ads` = status real das conexões ({ meta, google }): painel de anúncio só
// aparece no menu DEPOIS de conectado (decisão Ivan 26/08) — quem ainda não
// conectou faz tudo pela tela Conexões, sem menu fantasma.
export function buildMarketingMenu({ t, accountScopedRoute, ads = {} }) {
  return {
    name: 'Marketing',
    label: t('SIDEBAR.MARKETING'),
    icon: 'i-lucide-megaphone',
    children: [
      {
        name: 'MarketingPerformance',
        label: t('SIDEBAR.MARKETING_PERFORMANCE'),
        icon: 'i-lucide-chart-column',
        to: accountScopedRoute('marketing_performance'),
        activeOn: ['marketing_performance'],
      },
      // Um lugar SÓ para plugar canais (decisão Ivan 25/08): conexão não se
      // mistura com análise — cada painel analisa, aqui conecta.
      {
        name: 'MarketingConnections',
        label: t('SIDEBAR.MARKETING_CONNECTIONS'),
        icon: 'i-lucide-cable',
        to: accountScopedRoute('marketing_connections'),
        activeOn: ['marketing_connections'],
      },
      // Menu espelha a COBRANÇA (decisão Ivan 26/08): cada item/subgrupo é
      // uma cobrança. Estúdio Social = módulo (R$47, 1 conexão inclusa).
      {
        name: 'SocialStudio',
        label: t('SIDEBAR.SOCIAL_STUDIO'),
        icon: 'i-lucide-share-2',
        to: accountScopedRoute('social_calendar_index'),
        activeOn: [
          'social_calendar_index',
          'social_accounts_index',
          'social_metrics_index',
          'social_production_index',
          'social_feed_index',
        ],
      },
      // Módulo Captação (R$47): anúncios + formulários + links — o subgrupo
      // tem exatamente o que o módulo cobre.
      {
        name: 'Captation',
        label: t('SIDEBAR.CAPTATION'),
        icon: 'i-lucide-target',
        children: [
          ...(ads.meta
            ? [
                {
                  name: 'MetaAds',
                  label: t('SIDEBAR.META_ADS'),
                  icon: 'i-lucide-facebook',
                  to: accountScopedRoute('meta_ads_dashboard'),
                  activeOn: ['meta_ads_dashboard'],
                },
              ]
            : []),
          ...(ads.google
            ? [
                {
                  name: 'GoogleAds',
                  label: t('SIDEBAR.GOOGLE_ADS'),
                  icon: 'i-lucide-badge-dollar-sign',
                  to: accountScopedRoute('marketing_google_ads'),
                  activeOn: ['marketing_google_ads'],
                },
              ]
            : []),
        ],
      },
      // Módulo Formulários (R$47 — cobrança própria desde 26/08).
      {
        name: 'Forms',
        label: t('SIDEBAR.FORMS'),
        icon: 'i-lucide-file-text',
        to: accountScopedRoute('forms_list'),
        activeOn: ['forms_wrapper', 'forms_list', 'forms_new', 'forms_edit'],
      },
      // Prospecção (créditos por uso — não é módulo): busca de leads +
      // consulta CPF/CNPJ juntas.
      {
        name: 'Prospecting',
        label: t('SIDEBAR.PROSPECTING_HUB'),
        icon: 'i-lucide-magnet',
        children: [
          {
            name: 'ProspectingHub',
            label: t('SIDEBAR.PROSPECTOR'),
            icon: 'i-lucide-radar',
            to: accountScopedRoute('lead_prospector_index'),
            activeOn: [
              'lead_prospector_index',
              'prospecting_lists_index',
              'prospecting_dashboard',
            ],
          },
          {
            name: 'DocumentLookup',
            label: t('SIDEBAR.DOCUMENT_LOOKUP'),
            icon: 'i-lucide-id-card',
            to: accountScopedRoute('document_lookup_index'),
            activeOn: ['document_lookup_index'],
          },
        ],
      },
      // Growth Links é grátis (não entra em módulo nenhum) — item livre.
      {
        name: 'GrowthLinks',
        label: t('SIDEBAR.GROWTH_LINKS'),
        icon: 'i-lucide-link',
        to: accountScopedRoute('growth_links_list'),
        activeOn: [
          'growth_links_wrapper',
          'growth_links_list',
          'growth_links_new',
          'growth_links_edit',
        ],
      },
      {
        name: 'Campaigns',
        label: t('SIDEBAR.CAMPAIGNS'),
        icon: 'i-lucide-send',
        children: [
          {
            name: 'CampaignDispatches',
            label: t('SIDEBAR.CAMPAIGN_DISPATCHES'),
            icon: 'i-lucide-send',
            to: accountScopedRoute('campaigns_whatsapp_index'),
            // Wizard/canvas/flow/relatório são sub-telas sem item próprio:
            // sem elas aqui o menu "apagava" quando o usuário entrava nelas.
            activeOn: [
              'campaigns_whatsapp_index',
              'campaigns_whatsapp_wizard',
              'campaigns_whatsapp_canvas',
              'campaigns_whatsapp_flow',
              'campaigns_whatsapp_report',
            ],
          },
          // Resgatadas do limbo (existiam só por URL direta, sem menu):
          {
            name: 'CampaignTemplates',
            label: t('SIDEBAR.CAMPAIGN_TEMPLATES'),
            icon: 'i-lucide-layout-template',
            to: accountScopedRoute('campaigns_templates'),
            activeOn: ['campaigns_templates'],
          },
          {
            name: 'CampaignFollowUp',
            label: t('SIDEBAR.CAMPAIGN_FOLLOW_UP'),
            icon: 'i-lucide-list-restart',
            to: accountScopedRoute('campaigns_follow_up'),
            activeOn: ['campaigns_follow_up', 'campaigns_follow_up_detail'],
          },
          {
            name: 'CampaignBlacklist',
            label: t('SIDEBAR.CAMPAIGN_BLACKLIST_MENU'),
            icon: 'i-lucide-ban',
            to: accountScopedRoute('campaigns_blacklist'),
            activeOn: ['campaigns_blacklist'],
          },
          {
            name: 'ShortLinks',
            label: t('SIDEBAR.SHORT_LINKS'),
            icon: 'i-lucide-link',
            to: accountScopedRoute('campaigns_short_links_index'),
            activeOn: ['campaigns_short_links_index'],
          },
        ],
      },
    ],
  };
}
